export default __webpack_public_path__ + "static-json/ne_50m_rivers_lake_centerlines-e04e98a44d8bba3a110e2a055075fda1.json";